export default __webpack_public_path__ + "static/media/glass.e14f6fce.svg";